import React, { Fragment } from 'react';

import {
    Plugin,
    Template,
    TemplateConnector,
    TemplatePlaceholder,
} from '@devexpress/dx-react-core';

import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from 'devextreme-react';

const RefreshButtonComponent = (props) => {
    const { onRefresh, onReset } = props;
    return (
        <Fragment>
            <Tooltip
                title="Aggiorna Griglia"
                placement="bottom"
                enterDelay={300}
            >
                <IconButton onClick={() => onRefresh()} >
                    <RefreshIcon />
                </IconButton>
            </Tooltip>
            <Button
                text="Reset Filtri"
                type="default"
                stylingMode="contained"
                onClick={() => onReset()}
            />
        </Fragment>
    );
}

class CustomActionsBase extends React.Component {
    render() {
        const { refreshButtonComponent: RefreshButton } = this.props;

        return (
            <Plugin
                name="CustomActions"
                dependencies={[{ name: 'Toolbar' }, { name: 'CustomActionsState' }]}
            >
                <Template name="toolbarContent">
                    <TemplatePlaceholder />
                    <TemplateConnector>
                        {(getters, { clickRefresh, clickReset }) => (
                            <RefreshButton
                                onRefresh={clickRefresh}
                                onReset={clickReset}
                            />
                        )}
                    </TemplateConnector>
                </Template>
            </Plugin>
        );
    }
}

export default class CustomActions extends React.Component {
    render() {
        return (
            <CustomActionsBase
                refreshButtonComponent={RefreshButtonComponent}
                {...this.props}
            />
        );
    }


}